/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import { TrendingIcon } from '@coursera/cds-icons';

import { type MarketingStatusTag, trendingNowColors } from 'bundles/product-card/components/utils/marketingTagUtils';
import Badge from 'bundles/unified-description-page-common/components/shared/badges/Badge';
import NewAiBadge from 'bundles/unified-description-page-common/components/shared/badges/NewAiBadge';
import useShouldShowMerchPills from 'bundles/unified-description-page-common/hooks/useShouldShowMerchPills';
import { shouldShowNewAiSkillsBadge } from 'bundles/unified-description-page-common/utils/shouldShowNewAiSkillsBadge';

const styles = {
  svg: css`
    vertical-align: middle;
    margin-inline-end: var(--cds-spacing-25);
    margin-bottom: 2px;
  `,
};

type Props = {
  marketingTag: MarketingStatusTag;
  slug: string | undefined;
};

const TrendingRightNowBadge = ({ marketingTag, slug }: Props) => {
  const shouldShowMerchPills = useShouldShowMerchPills();

  if (shouldShowMerchPills) {
    return (
      <Badge color={trendingNowColors}>
        <TrendingIcon size="small" css={styles.svg} />
        {marketingTag.tag}
      </Badge>
    );
  }

  return shouldShowNewAiSkillsBadge(slug) ? <NewAiBadge slug={slug} /> : null;
};

export default TrendingRightNowBadge;
